import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  FaHome,
  FaInfoCircle,
  FaListUl,
  FaEnvelope,
  FaBars,
  FaTimes,
  FaCog,
  FaCaretDown,
  FaUserCheck,
  FaChartLine,
  FaUsers,
  FaArrowRight,
  FaPlayCircle,
  FaCheckCircle,
  FaStar,
  FaMagic,
  FaGlobe,
  FaArrowUp,
  FaBolt,
  FaChartBar,
  FaShieldAlt,
  FaMobileAlt,
  FaRocket,
  FaBuilding,
  FaSmile,
  FaHeadset,
  FaLightbulb,
  FaSyncAlt,
  FaCloud,
  FaLock,
  FaAward,
  FaCogs,
  FaChevronDown,
  FaRobot,
  FaClipboardCheck,
  FaFileInvoiceDollar,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaInstagram,
  FaCalendarAlt,
  FaClock,
  FaFileAlt,
  FaBell,
  FaTimesCircle,
  FaFolder,
  FaLink,
  FaEllipsisH,
  FaCopy,
  FaEye,
  FaEdit,
  FaShare,
  FaUser,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { BarChart3, Users, TrendingUp } from 'lucide-react';
import './HomePage.css';
import { BiSparkles } from 'react-icons/bi';
import { MdInfo } from 'react-icons/md';
import PricingModule from './PricingModule';
import HRCopilotCarousel from './HRCopilotCarousel';
import HRCopilotOnboarding from './HRCopilotOnboarding';
import HRCopilotFAQ from './HRCopilotFAQ';
import Management from './Management';
import HRCopilotAllApps from './HRCopilotAllApps';
import HRCopilotProductivity from './HRCopilotProductivity';
import HRCopilotEnterprise from './HRCopilotEnterprise';
import FeatureShowcase from './FeatureShowcase';
import Hero from './Hero';
import HRCopilotScheduling from './HRCopilotScheduling';
import HRCopilotPipeline from './HRCopilotPipeline';
import HRCopilotLanding from './HRCopilotLanding';
import HRCopilotEraSection from './HRCopilotEraSection';
import ContactSection from './ContactSection';
import HRCopilotFeatures from './HRCopilotFeatures';
import HRBusinessSection from './HRBusinessSection';
import HRNewsletter from './HRNewsletter';
import HRCopilotProfessionals from './HRCopilotProfessionals';
import ResiStepSection from './ResiStepSection';
import ResoOfferSection from './ResoOfferSection';
import HRCopilotNewsSection from './HRCopilotNewsSection';
import TestimonialSlider from './TestimonialSlider';
import CTA from './CTA';
import HRPlatformShowcase from './Showcase';
import CustomerOutcomeShowcase from './CustomerOutcomeShowcase';
import HumanexAICompanion from './HumanexAICompanion';
import HomePricingSection from './HomePricingSection';
import useSEO from "../utils/useSEO";

// import PricingModule from './PricingModule';

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [activeFeature, setActiveFeature] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [featuresOpen, setFeaturesOpen] = useState(false);
  const [activeTestimonial, setActiveTestimonial] = useState(null);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const videoRef = useRef(null);
  const [scrollY, setScrollY] = useState(0);

  const [activeTab, setActiveTab] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeImage, setActiveImage] = useState("/images/main.png");
  const [activeSection, setActiveSection] = useState(1);
  const sectionsRef = useRef([]);

  // Authentication states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoginForm, setIsLoginForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [signupStep, setSignupStep] = useState(false);
  const [signupOtp, setSignupOtp] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    employees: "",
    password: "",
  });
  const [loginStep, setLoginStep] = useState(false);
  const [loginData, setLoginData] = useState({ email: "", otp: "" });
  const [resendTimer, setResendTimer] = useState(0);
  const modalRef = useRef(null);

  useSEO({
    title: "Humanex | Recruitment, Staffing & Onboarding Services",
    description:
      "Humanex delivers professional recruitment, staffing, and employee onboarding services to help businesses hire the right talent and build strong teams.",
  });

  // Onboarding data state
  const [onboardingData, setOnboardingData] = useState(null);

  const navigate = useNavigate();
  const handleDemo = () => navigate('/book-demo');

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + window.innerHeight / 2;

      sectionsRef.current.forEach((section, index) => {
        if (section) {
          const rect = section.getBoundingClientRect();
          const sectionTop = rect.top + window.scrollY;
          const sectionBottom = sectionTop + rect.height;

          if (scrollPos >= sectionTop && scrollPos <= sectionBottom) {
            setActiveSection(index + 1);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Listen for onboarding events from other components
// In HomePage.js - update the useEffect for event listeners
useEffect(() => {
  const handleOpenAuthModal = (event) => {
    console.log('🏠 HomePage: Opening auth modal', event.detail);
    setIsModalOpen(true);
    setIsLoginForm(event.detail.isLoginForm || false);
    
    // Reset form states when opening
    setSignupStep(false);
    setLoginStep(false);
    setFormData({
      name: "",
      email: "",
      company: "",
      employees: "",
      password: "",
    });
    setLoginData({ email: "", otp: "" });
    setSignupOtp("");
    setMessage({ type: "", text: "" });
    setOnboardingData(null);
  };

  const handleOnboardingRequest = (event) => {
    console.log('🏠 HomePage: Received onboarding request', event.detail);
    
    const { candidateData, offerData } = event.detail;
    
    // Store onboarding data
    setOnboardingData({
      candidateName: candidateData?.candidateName,
      candidateEmail: candidateData?.candidateEmail,
      position: candidateData?.position,
      department: candidateData?.department,
      joiningDate: candidateData?.joiningDate,
      companyName: candidateData?.companyName,
      fromOnboarding: true
    });

    console.log('🏠 HomePage: Opening auth modal for onboarding');
    
    // Open auth modal with signup form
    setIsModalOpen(true);
    setIsLoginForm(false);
    setSignupStep(false);
    
    // Pre-fill form data if available
    if (candidateData?.candidateEmail) {
      setFormData(prev => ({
        ...prev,
        email: candidateData.candidateEmail,
        name: candidateData.candidateName || '',
        company: candidateData.companyName || ''
      }));
    }
  };

  console.log('🏠 HomePage: Setting up event listeners');
  
  window.addEventListener('openAuthModal', handleOpenAuthModal);
  window.addEventListener('startOnboarding', handleOnboardingRequest);
  
  return () => {
    window.removeEventListener('openAuthModal', handleOpenAuthModal);
    window.removeEventListener('startOnboarding', handleOnboardingRequest);
  };
}, []);

  const logos = [
    '/images/run1.png',
    '/images/run2.png',
    '/images/run3.png',
    '/images/run4.png',
    '/images/run5.png',
    '/images/run6.png',
    '/images/run7.png',
    '/images/run8.png',
  ];

  const features1 = [
    {
      id: 0,
      icon: '01',
      title: 'Add employees quickly',
      description: 'Migrate your employee data to HR Copilot People in just a few steps. You can import, add, and invite users directly or sync them through Mail, Office 365, and Google Workspace integrations.',
      image: '/images/z1.png'
    },
    {
      id: 1,
      icon: '02',
      title: 'Organize multiple business entities',
      description: 'From adding your business entities and their different divisions to building your organization structure, you can effortlessly manage your employee data from within HR Copilot People.',
      image: '/images/z2.png'
    },
    {
      id: 2,
      icon: '03',
      title: 'Automate employee ID generation',
      description: 'Keep employee records organized and secure by automatically generating ID numbers based on custom parameters like entity, location, department, prefixes, and suffixes.',
      image: 'https://www.zohowebstatic.com/sites/zweb/images/people/zpl-emp-id-gen-config.jpg'
    },
    {
      id: 3,
      icon: '04',
      title: 'Classify your workforce',
      description: 'Set the foundation for error-free management, from payroll and admin actions to performance and learning management by dividing your workforce into departments, designations, and locations.',
      image: 'https://www.zohowebstatic.com/sites/zweb/images/people/zpl-classify-workforce.jpg'
    }
  ];

  const sections = [
    {
      id: 1,
      title: "Network Analytics",
      description: "Leverage network specific, cross-network, paid, competitive and internal reports to highlight your most important data in visuals that tell a story",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80"
    },
    {
      id: 2,
      title: "Audience Insights",
      description: "Deep dive into audience demographics, behavior patterns, and engagement metrics to understand your users better and optimize your content strategy",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
    },
    {
      id: 3,
      title: "Performance Tracking",
      description: "Monitor key performance indicators in real-time, track campaign success, and make data-driven decisions to maximize your ROI",
      image: "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800&q=80"
    }
  ];

  const currentSection = sections[activeSection - 1];

  const cards = [
    { icon: "🎯", title: "Smart Recruitment", desc: "AI-powered candidate screening and intelligent job matching" },
    { icon: "📊", title: "Analytics Dashboard", desc: "Real-time insights into workforce metrics and trends" },
    { icon: "🚀", title: "Quick Onboarding", desc: "Streamlined digital onboarding process in minutes" },
    { icon: "💼", title: "Talent Management", desc: "Comprehensive employee lifecycle management tools" },
    { icon: "🔒", title: "Data Security", desc: "Bank-level encryption and compliance protection" },
    { icon: "⚡", title: "Automated Workflows", desc: "Eliminate repetitive tasks with smart automation" }
  ];

  const steps = [
    {
      num: "01",
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M16 4L18 14L28 16L18 18L16 28L14 18L4 16L14 14L16 4Z" fill="url(#icon-gradient-1)" />
          <defs>
            <linearGradient id="icon-gradient-1" x1="4" y1="4" x2="28" y2="28">
              <stop offset="0%" stopColor="#667eea" />
              <stop offset="100%" stopColor="#764ba2" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Connect Your Systems",
      desc: "Seamlessly integrate with your existing HRIS, payroll, and communication tools. Our smart connectors automatically sync your employee data in real-time.",
      features: ["One-click integrations", "Real-time data sync", "Secure encryption"]
    },
    {
      num: "02",
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <rect x="6" y="10" width="20" height="16" rx="2" stroke="url(#icon-gradient-2)" strokeWidth="2" fill="none" />
          <path d="M10 6H22C23.1046 6 24 6.89543 24 8V10H8V8C8 6.89543 8.89543 6 10 6Z" fill="url(#icon-gradient-2)" />
          <circle cx="16" cy="18" r="3" fill="url(#icon-gradient-2)" />
          <defs>
            <linearGradient id="icon-gradient-2" x1="6" y1="6" x2="26" y2="26">
              <stop offset="0%" stopColor="#667eea" />
              <stop offset="100%" stopColor="#764ba2" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Train Your AI Assistant",
      desc: "Customize HR Copilot to understand your company culture, policies, and workflows. The AI learns your preferences and adapts to your team's unique needs.",
      features: ["Custom policy training", "Culture alignment", "Workflow automation"]
    },
    {
      num: "03",
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="12" r="5" stroke="url(#icon-gradient-3)" strokeWidth="2" fill="none" />
          <path d="M8 26C8 21.5817 11.5817 18 16 18C20.4183 18 24 21.5817 24 26" stroke="url(#icon-gradient-3)" strokeWidth="2" strokeLinecap="round" />
          <circle cx="24" cy="10" r="3" fill="url(#icon-gradient-3)" />
          <circle cx="8" cy="10" r="3" fill="url(#icon-gradient-3)" />
          <defs>
            <linearGradient id="icon-gradient-3" x1="8" y1="8" x2="24" y2="26">
              <stop offset="0%" stopColor="#667eea" />
              <stop offset="100%" stopColor="#764ba2" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Onboard Your Team",
      desc: "Roll out HR Copilot with guided onboarding for HR staff and employees. Interactive tutorials and 24/7 support ensure smooth adoption across your organization.",
      features: ["Interactive tutorials", "Live support", "Role-based training"]
    },
    {
      num: "04",
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M4 16L12 24L28 8" stroke="url(#icon-gradient-4)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="16" cy="16" r="14" stroke="url(#icon-gradient-4)" strokeWidth="2" fill="none" opacity="0.3" />
          <defs>
            <linearGradient id="icon-gradient-4" x1="4" y1="8" x2="28" y2="24">
              <stop offset="0%" stopColor="#667eea" />
              <stop offset="100%" stopColor="#764ba2" />
            </linearGradient>
          </defs>
        </svg>
      ),
      title: "Scale & Optimize",
      desc: "Monitor performance metrics and let AI continuously optimize your HR processes. Expand capabilities as your needs grow with advanced automation features.",
      features: ["Performance analytics", "Continuous optimization", "Advanced automation"]
    }
  ];

  const tabs = [
    {
      title: "Plan & schedule content",
      desc: "Simplify workflows and collaboration to keep your brand active where it matters most.",
      image: "/images/dashe1.png",
    },
    {
      title: "Engage with customers",
      desc: "Use AI to reply with speed, empathy and consistency across all channels.",
      image: "/images/Dash2.png",
    },
    {
      title: "Analyze your performance",
      desc: "Track insights that support business goals and showcase your brand impact.",
      image: "/images/Dash3.png",
    },
    {
      title: "Discover trends & insights",
      desc: "Tap into real-time conversations to understand what your audience cares about.",
      image: "/images/Dash1 (3).png",
    },
  ];

  const slides = [
    {
      title: "Smart HR Management",
      subtitle: "for India's most innovative companies",
      tagline: "Automated Workflows | AI-Powered Insights | Complete Integration",
      ctaPrimary: "Get Started",
      ctaSecondary: "Learn More",
      founder: "HR Tech Leader",
      founderName: "Priya",
      productName: "HR Copilot Suite",
      productTagline: "POWERS",
      brandName: "SMARTHR",
      image: "https://framerusercontent.com/images/wbiGlgM3MnvENjxeAwDiWdOGWRA.png?scale-down-to=1024&width=1500&height=1650"
    },
    {
      title: "Effortless Employee Onboarding",
      subtitle: "for growing businesses across India",
      tagline: "Digital Documents | Quick Setup | Seamless Experience",
      ctaPrimary: "Start Free Trial",
      ctaSecondary: "View Demo",
      founder: "Operations Expert",
      founderName: "Rahul",
      productName: "Onboarding Pro",
      productTagline: "POWERED BY",
      brandName: "QUICKHIRE",
      image: "https://framerusercontent.com/images/W01xvgQIO331lW0m2ebzY6ky8p4.png?scale-down-to=1024&width=738&height=1386"
    },
    {
      title: "Intelligent Payroll Processing",
      subtitle: "for modern HR teams",
      tagline: "Auto-Calculation | Compliance Ready | Real-time Reports",
      ctaPrimary: "Sign Up Now",
      ctaSecondary: "Explore Features",
      founder: "Finance Specialist",
      founderName: "Amit",
      productName: "PayMaster",
      productTagline: "BUILT WITH",
      brandName: "PAYPRO",
      image: "https://framerusercontent.com/images/wbiGlgM3MnvENjxeAwDiWdOGWRA.png?scale-down-to=1024&width=1500&height=1650"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const slide = slides[currentSlide];

  const features = [
    {
      title: "Employee Management",
      description: "Streamline HR workflows and collaboration to ensure your team is always connected and productive throughout the employee lifecycle.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=800&fit=crop",
      gradient: "linear-gradient(135deg, #e879f9 0%, #ffffffff 50%, #ffffffff 100%)"
    },
    {
      title: "Performance Tracking",
      description: "Leverage AI to monitor employee performance with real-time insights, creating consistent, data-driven evaluation experiences at scale.",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=800&fit=crop",
      gradient: "linear-gradient(180deg,#026661 .67%,#98E58E 49.88%,#D7F4D7 86.49%,#FFF 104.08%),#040404"
    },
    {
      title: "Analytics Dashboard",
      description: "Access comprehensive analytics that reveal workforce insights to inform business goals and showcase your HR impact effectively.",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=800&fit=crop",
      gradient: "linear-gradient(135deg, #f59e0b 0%, #f97316 50%, #ea580c 100%)"
    },
    {
      title: "Talent Insights",
      description: "Tap into real-time talent intelligence to identify recruitment trends and understand what's next for your workforce and industry.",
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&h=800&fit=crop",
      gradient: "linear-gradient(135deg, #3b82f6 0%, #2563eb 50%, #1d4ed8 100%)"
    }
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    const featureTimer = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % 3);
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearInterval(featureTimer);
    };
  }, []);

  const handleLinkClick = () => {
    setMenuOpen(false);
    setFeaturesOpen(false);
  };

  // Authentication functions
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  const handleInputChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleLoginInputChange = (e) =>
    setLoginData({ ...loginData, [e.target.name]: e.target.value });

  const startResendTimer = () => {
    setResendTimer(60);
    const interval = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: "", text: "" }), 4000);
  };

  const handleGetStarted = () => {
    const event = new CustomEvent('openAuthModal', {
      detail: { isLoginForm: false }
    });
    window.dispatchEvent(event);
  };

  const handleLogin = () => {
    const event = new CustomEvent('openAuthModal', {
      detail: { isLoginForm: true }
    });
    window.dispatchEvent(event);
    setMenuOpen(false);
    setFeaturesOpen(false);
  };

  // Auth modal close function
  const onClose = () => {
    setIsModalOpen(false);
    setSignupStep(false);
    setLoginStep(false);
    setOnboardingData(null);
    setFormData({
      name: "",
      email: "",
      company: "",
      employees: "",
      password: "",
    });
    setLoginData({ email: "", otp: "" });
    setSignupOtp("");
    setMessage({ type: "", text: "" });
  };

  // Auth switch function
  const handleAuthSwitch = () => {
    setIsLoginForm(!isLoginForm);
    setSignupStep(false);
    setLoginStep(false);
    setOnboardingData(null);
    setFormData({
      name: "",
      email: "",
      company: "",
      employees: "",
      password: "",
    });
    setLoginData({ email: "", otp: "" });
    setSignupOtp("");
    setMessage({ type: "", text: "" });
  };

  // Enhanced Signup Flow with Onboarding Support
  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage({ type: "", text: "" });

    try {
      if (!signupStep) {
        const res = await fetch(`${API_BASE_URL}/api/auth/signup-send-otp`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...formData,
            onboardingData: onboardingData
          }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Failed to send OTP");

        setSignupStep(true);
        startResendTimer();
        showMessage("success", "OTP sent to your email. Please verify.");
      } else {
        const res = await fetch(`${API_BASE_URL}/api/auth/signup-verify-otp`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ 
            ...formData, 
            otp: signupOtp,
            onboardingData: onboardingData
          }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Invalid OTP");

        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("companyId", data.companyId);
        sessionStorage.setItem("companyName", formData.company);
        sessionStorage.setItem("userName", formData.name);
        
        // Store onboarding data in session for the onboarding process
        if (onboardingData) {
          sessionStorage.setItem("onboardingData", JSON.stringify(onboardingData));
        }

        showMessage("success", onboardingData ? "Account created! Starting onboarding..." : "Account created successfully!");
        
        setTimeout(() => {
          onClose();
          // Redirect to onboarding if it's from onboarding process
          if (onboardingData) {
            navigate("/onboarding", { 
              state: { 
                onboardingData: onboardingData,
                newUser: true 
              } 
            });
          } else {
            navigate("/dashboard");
          }
        }, 1000);
      }
    } catch (err) {
      showMessage("error", err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Login Flow
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage({ type: "", text: "" });

    try {
      if (!loginStep) {
        const res = await fetch(`${API_BASE_URL}/api/auth/login-send-otp`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: loginData.email }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Failed to send OTP");

        setLoginStep(true);
        startResendTimer();
        showMessage("success", "OTP sent to your email.");
      } else {
        const res = await fetch(`${API_BASE_URL}/api/auth/login-verify-otp`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(loginData),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Invalid OTP");

        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("companyId", data.companyId);
        sessionStorage.setItem("companyName", data.companyName);
        sessionStorage.setItem("userName", data.userName);

        showMessage("success", "Login successful!");
        setTimeout(() => {
          onClose();
          navigate("/dashboard");
        }, 1000);
      }
    } catch (err) {
      showMessage("error", err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Resend OTP
  const handleResendOtp = async (type) => {
    setIsSubmitting(true);
    setMessage({ type: "", text: "" });

    try {
      const endpoint = `${API_BASE_URL}/api/auth/resend-otp`;
      const body = type === "signup" ? { 
        email: formData.email,
        onboardingData: onboardingData 
      } : { email: loginData.email };

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to resend OTP");

      startResendTimer();
      showMessage("success", "New OTP sent!");
    } catch (err) {
      showMessage("error", err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Google Login
  const handleGoogleLogin = () => {
    window.location.href = `${API_BASE_URL}/api/google-auth/google`;
  };

  // Handle Sign In button click
  const handleSignIn = () => {
    setIsModalOpen(true);
    setIsLoginForm(true);
    setLoginStep(false);
    setLoginData({ email: "", otp: "" });
  };

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  return (
    <div className={`hrc-container ${isLoading ? 'hrc-loading' : 'hrc-loaded'}`}>
      {/* Enhanced Animated Background */}
      <div className="hrc-background-animation">
        <div className="hrc-particles">
          {[...Array(50)].map((_, i) => (
            <div key={i} className="hrc-particle" style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${15 + Math.random() * 10}s`
            }}></div>
          ))}
        </div>
        <div className="hrc-floating-shapes">
          {/* <div className="hrc-shape hrc-shape-1"></div>
          <div className="hrc-shape hrc-shape-2"></div>
          <div className="hrc-shape hrc-shape-3"></div>
          <div className="hrc-shape hrc-shape-4"></div> */}
        </div>
      </div>

      {/* Main Content Sections */}
      <HRCopilotAllApps/>
      <HRCopilotFeatures/>
      <HRPlatformShowcase/>
      <CustomerOutcomeShowcase/>
      <HomePricingSection/>
      <HumanexAICompanion/>
      <HRCopilotNewsSection/>
      {/* <HRCopilotProfessionals/> */}
      {/* <Management/> */}
      {/* <HRCopilotFAQ/> */}
      {/* <PricingModule/> */}
      {/* <ResiStepSection/> */}
      {/* <ResoOfferSection/> */}
      {/* <ContactSection/> */}        
      {/* <HRBusinessSection/> */}
      {/* <HRCopilotLanding/> */}
      {/* <HRCopilotPipeline/> */}
      {/* <HRNewsletter/> */}
      {/* <CTA/> */}
      {/* <TestimonialSlider/> */}            
      {/* <HRCopilotEnterprise/> */}
      {/* <HRCopilotEraSection/> */}
     
   

      {/* Auth Modal */}
      {isModalOpen && (
        <div className="hr-auth-modal">
          <div className="hr-auth-modal__backdrop"></div>
          <div className="hr-auth-modal__container" ref={modalRef}>
            <div className="hr-auth-modal__content">
              <button className="hr-auth-modal__close" onClick={onClose}>
                <FaTimes />
              </button>

              <div className="hr-auth-modal__header">
                <div className="hr-auth-modal__logo">
                  <div className="hr-auth-modal__logo-icon">
                    <FaRocket />
                  </div>
                  <h2>HR Copilot</h2>
                </div>
                
                {/* Onboarding Welcome Message */}
                {onboardingData && (
                  <div className="hr-auth-modal__onboarding-welcome">
                    <div className="hr-auth-modal__onboarding-badge">
                      🚀 Welcome to {onboardingData.companyName || 'Our Company'}
                    </div>
                    <p className="hr-auth-modal__onboarding-text">
                      Complete your registration to start the onboarding process for 
                      <strong> {onboardingData.position}</strong>
                    </p>
                  </div>
                )}
                
                <h3 className="hr-auth-modal__title">
                  {onboardingData ? "Complete Your Registration" : 
                   isLoginForm ? "Welcome Back" : "Get Started"}
                </h3>
                <p className="hr-auth-modal__subtitle">
                  {onboardingData 
                    ? "Create your account to begin your onboarding journey"
                    : isLoginForm
                      ? "Sign in to your account to continue"
                      : "Create your account to streamline HR operations"
                  }
                </p>
              </div>

              {/* Google Login Button */}
              {/* <button
                className="hr-auth-modal__google-btn"
                onClick={handleGoogleLogin}
              >
                <svg className="hr-auth-modal__google-icon" viewBox="0 0 24 24" width="20" height="20">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                </svg>
                Continue with Google
              </button> */}

              <div className="hr-auth-modal__divider">
                <span>or continue with email</span>
              </div>

              <form onSubmit={isLoginForm ? handleLoginSubmit : handleSignupSubmit} className="hr-auth-modal__form">
                {isLoginForm ? (
                  <>
                    <div className="hr-auth-modal__input-group">
                      <input
                        type="email"
                        name="email"
                        value={loginData.email}
                        onChange={handleLoginInputChange}
                        placeholder="Work Email"
                        required
                        disabled={loginStep}
                        className="hr-auth-modal__input"
                      />
                    </div>
                    {loginStep && (
                      <div className="hr-auth-modal__input-group">
                        <input
                          type="text"
                          name="otp"
                          value={loginData.otp}
                          onChange={handleLoginInputChange}
                          placeholder="Enter OTP"
                          required
                          className="hr-auth-modal__input"
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div className="hr-auth-modal__input-group">
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Full Name"
                        required
                        className="hr-auth-modal__input"
                      />
                    </div>
                    <div className="hr-auth-modal__input-group">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Work Email"
                        required
                        className="hr-auth-modal__input"
                      />
                    </div>
                    <div className="hr-auth-modal__input-group">
                      <input
                        type="text"
                        name="company"
                        value={formData.company}
                        onChange={handleInputChange}
                        placeholder="Company Name"
                        required
                        className="hr-auth-modal__input"
                      />
                    </div>
                    <div className="hr-auth-modal__input-group">
                      <select
                        name="employees"
                        value={formData.employees}
                        onChange={handleInputChange}
                        required
                        className="hr-auth-modal__input"
                      >
                        <option value="">Select Company Size</option>
                        <option value="1-50">1-50 employees</option>
                        <option value="51-200">51-200 employees</option>
                        <option value="201-500">201-500 employees</option>
                        <option value="501-1000">501-1000 employees</option>
                        <option value="1000+">1000+ employees</option>
                      </select>
                    </div>
                    <div className="hr-auth-modal__input-group">
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="Password"
                        required
                        className="hr-auth-modal__input"
                      />
                    </div>
                    {signupStep && (
                      <div className="hr-auth-modal__input-group">
                        <input
                          type="text"
                          name="otp"
                          value={signupOtp}
                          onChange={(e) => setSignupOtp(e.target.value)}
                          placeholder="Enter OTP"
                          required
                          className="hr-auth-modal__input"
                        />
                      </div>
                    )}
                  </>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="hr-auth-modal__submit-btn"
                >
                  {isSubmitting
                    ? isLoginForm
                      ? loginStep
                        ? "Verifying..."
                        : "Sending OTP..."
                      : signupStep
                        ? "Verifying..."
                        : "Creating Account..."
                    : isLoginForm
                      ? loginStep
                        ? "Verify OTP"
                        : "Send OTP"
                      : signupStep
                        ? "Verify OTP"
                        : "Create Account"}
                </button>

                {(loginStep || signupStep) && (
                  <div className="hr-auth-modal__otp-section">
                    {resendTimer > 0 ? (
                      <p className="hr-auth-modal__resend-timer">
                        Resend OTP in <span>{resendTimer}s</span>
                      </p>
                    ) : (
                      <button
                        type="button"
                        className="hr-auth-modal__resend-btn"
                        onClick={() => handleResendOtp(isLoginForm ? "login" : "signup")}
                        disabled={isSubmitting}
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>
                )}
              </form>

              {message.text && (
                <div className={`hr-auth-modal__message ${message.type === "error" ? "hr-auth-modal__message--error" : "hr-auth-modal__message--success"}`}>
                  {message.text}
                </div>
              )}

              <div className="hr-auth-modal__footer">
                <p>
                  {isLoginForm ? "Don't have an account? " : "Already have an account? "}
                  <button
                    type="button"
                    className="hr-auth-modal__switch-btn"
                    onClick={handleAuthSwitch}
                  >
                    {isLoginForm ? "Sign up" : "Sign in"}
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Video Modal */}
      <div
        className={`hrcp-modal-overlay ${authModalOpen ? 'hrcp-active' : ''}`}
        onClick={() => setAuthModalOpen(false)}
      >
        <div className="hrcp-modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="hrcp-modal-close" onClick={() => setAuthModalOpen(false)}>
            ×
          </button>
          <div className="hrcp-video-container">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/kcckpWgkhP0?si=F2ZUmyLRaJE7sEuU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;